import { optionsPerfil } from './optionsPerfil';

export const dataKeys = {
  tipoHospital: {
    titulo: '1. Qual o tipo de estabelecimento?',
    order: 1,
    opcoes: {
      g: {
        resposta: 'Hospital Geral',
      },
      e: {
        resposta: 'Hospital Especializado',
        subItens: optionsPerfil.filter(
          item => item.grupo === 'tipo_estabelecimento'
        ),
      },
    },
  },
  numeroDeLeitos: {
    titulo: '2. Qual o número de leitos da instituição?',
    order: 2,
    opcoes: [],
  },
  perfilEtario: {
    titulo: '3. Qual o perfil etário de pacientes atendidos pela instituição?',
    ordem: 3,
    opcoes: optionsPerfil.filter(item => item.grupo === 'perfil_etario'),
  },
  perfilInternacaoHospitalar: {
    titulo: '4. Quais os perfis de internação hospitalar?',
    ordem: 4,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'perfil_internacao_hospitalar'
    ),
  },
  corpoClinicoHospital: {
    titulo: '5. Como é a relação do corpo clínico do hospital?',
    ordem: 5,
  },
  instituicaoDeEnsino: {
    titulo: '6. A instituição é um hospital de ensino?',
    ordem: 6,
    opcoes: [],
  },
  programaDeResidencia: {
    titulo: '7. A instituição possui programa de residência?',
    ordem: 7,
    opcoes: [],
  },
  totalDeMedicos: {
    titulo: '8. Total de médicos(as) que atuam na instituição:',
    ordem: 8,
    opcoes: [],
  },
  totalDeEnfermeiros: {
    titulo: '9. Total de enfermeiros(as) que atuam na instituição:',
    ordem: 9,
    opcoes: [],
  },
  totalDeTecnicos: {
    titulo:
      '10. Total de técnicos(as) de enfermagem que atuam na instituição: ',
    ordem: 10,
    opcoes: [],
  },
  totalDeEmpregados: {
    titulo:
      '11. Total de funcionários(as) ativos(as) que atuam na instituição ',
    ordem: 11,
    opcoes: [],
  },
  metricaNPS: {
    titulo: '12. A instituição acompanha a métrica Net Promoter Score (NPS)? ',
    ordem: 12,
    opcoes: [],
  },
  usoDRG: {
    titulo:
      '13. A instituição faz uso da metodologia Diagnosis Related Groups (DRGs)? ',
    ordem: 13,
    opcoes: [],
  },
  usoProtocolosClinicosInstitucionais: {
    titulo: '14. A instituição faz uso de protocolos institucionais?',
    ordem: 14,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'protocolos_clinicos_institucionais'
    ),
  },
  usaProntuarioSistemaInformatizado: {
    titulo:
      '15. A instituição faz uso de prontuário eletrônico ou sistema informatizado? ',
    ordem: 15,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'sistema_informatizado_protuario'
    ),
  },
  usaProgramaAvaliacaoIndicadoresHospitalar: {
    titulo:
      '16. O hospital participa de algum programa de avaliação de qualidade por meio de indicadores?',
    ordem: 16,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'sistema_informatizado_avaliacao'
    ),
  },
  usaCertificadoPrograma: {
    titulo: '17. A instituição é acreditada/certificada por algum programa?   ',
    ordem: 17,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'certificacao_programa'
    ),
  },
  monitoramentoDeIndicadores: {
    titulo:
      '18. A instituição faz busca ativa de pacientes para o monitoramento de indicadores?',
    ordem: 18,
    opcoes: [],
  },
  coordenaEstudosClinicos: {
    titulo: '19. A instituição participa/coordena estudos clínicos?',
    ordem: 19,
    opcoes: [],
  },
  possuiUnidadeDeEmergencia: {
    titulo: '20. Possui Unidade de Emergência? ',
    ordem: 20,
    opcoes: [],
  },
  atendimentoEmergencia: {
    titulo: '21. Atendimento da emergência ',
    ordem: 21,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'atendimento_emergencia'
    ),
  },
  possuiEmergenciaEspecializada: {
    titulo: '22. Possui emergência especializada? ',
    ordem: 22,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'emergencia_especializada'
    ),
  },
  estratificacaoDeRiscoNaEmergencia: {
    titulo: '23. Utiliza protocolo de estratificação de risco na emergência?',
    ordem: 23,
    opcoes: optionsPerfil.filter(item => item.grupo === 'estratificacao_risco'),
  },

  atendeEmergenciaAdulto: {
    titulo: '24. Atende pacientes adultos na emergência?',
    ordem: 24,
    opcoes: [],
  },

  atendeEmergenciaPediatrico: {
    titulo: '25. Atende pacientes pediátricos na emergência?',
    ordem: 25,
    opcoes: [],
  },
  totalDeLietosEmergencia: {
    titulo: '26. Total de leitos na(s) emergência(s): ',
    ordem: 26,
    opcoes: [],
  },

  timeDeRespostaRapida: {
    titulo: '27. Possui Time de Resposta Rápida (TRR) ou equivalente?',
    ordem: 27,
    opcoes: [],
  },

  diagnosticoTerapeutico: {
    titulo: '29. Quais os serviços de apoio o hospital possui?',
    ordem: 29,
    opcoes: optionsPerfil.filter(
      item => item.grupo === 'diagnotico_terapeutico'
    ),
  },

  utiEspecializada: {
    ordem: 28,
    opcoes: optionsPerfil.filter(item => item.grupo === 'uti_especializada'),
  },

  //
  //
  //
  //
  //
  //
  //
};
